import { defaultPagination } from "../../../reducers/collectionPointReducer";
import { cleanUpCollectionYardsList, setCollectionYardsListPagination } from "../../../reducers/collectionYardsReducer";
import { AppDispatch } from "../../../store";

export const resetCollectionYards = (dispatch: AppDispatch): void => {
  dispatch(cleanUpCollectionYardsList());
  dispatch(setCollectionYardsListPagination(defaultPagination));
};
